import React from 'react';
import { useParams } from 'react-router-dom';
import { FormProvider } from 'contexts/FormContext';
import CreateProjectForm from 'components/CreateProjectForm';

const FormScreen = () => {
  // Get businessId from URL parameters
  let { businessId } = useParams();
  
  return (
    <FormProvider businessId={businessId}>
      <CreateProjectForm />
    </FormProvider>
  );
};

export default FormScreen;
